// React context that carries the injected AgentsApiClient.
// Kept in its own file so the provider component can live in a
// component-only file (react-refresh fast-refresh boundary rule).

import { createContext } from 'react';
import type { AgentsApiClient } from './types';

export const AgentsApiContext = createContext<AgentsApiClient | null>(null);
